import React, { FC, useEffect, useState } from "react";
import {
  Cell,
  Dot,
  DotProps,
  Label,
  ReferenceArea,
  ReferenceLine,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  YAxis,
  ZAxis,
} from "recharts";
import { numberFormatter } from "../../utils";



const ScatterCharts = (props: any) => {
  const { data, selectedCustomerData, minYAxis, maxYAxis, tableHeight } = props;

  
  const [graphData, setGraphData] = useState<any>([]);

  const prepareGraphData = () => {
    let finalData: any = [];
    
    Object.keys(data).forEach((element: any, index: number) => {
      let obj = { data: null, xAxis: 0, referenceLine: 0  ,opportunity : null},
        generateData: any = [];
        
      // data[element].sort((a: any, b: any) => b.opportunity - a.opportunity);

      data[element].forEach(($: any) => {
        let obj1 = {};
        if ($.customer === selectedCustomerData.customer) {
          obj.referenceLine = $.executedPrice;
          obj.opportunity = $.opportunity
        }
        // data[element].index=(index+1)*2
        obj1 = {
          // index: (index + 1) * (Object.keys(data)?.length>=3?2:(Object.keys(data)?.length==1?5:4)),
          value: $?.price,
          volume: $?.volume,
          revenue: $?.revenue,
          segment: $?.Customer_Class,
          description: $?.customerDesc,
          customer: $?.customer,
        };
        generateData.push(obj1);
      });

      // obj.xAxis = (index + 1) * 2;
      // obj.xAxis = (index + 1) * (Object.keys(data)?.length>=3?2:(Object.keys(data)?.length==1?5:4));
      obj.data = generateData;
      
      
      finalData.push(obj);
    });
    
    finalData.sort((a: any, b: any) => a.opportunity > b.opportunity ? -1 : 1);
    finalData.forEach((element: any , index : number) => {
      element.xAxis = (index + 1) * (Object.keys(data)?.length>=3?2:(Object.keys(data)?.length==1?5:4));
      element.data.forEach((insideelement: any, index : number) => {
        insideelement.index = element.xAxis
      });
      
    });
    setGraphData(finalData);
  };
  

  useEffect(() => {
    if (props?.data) {
      prepareGraphData();
    }
  }, [props?.data]);

  const CustomTooltip = (props: any) => {
    const { active, payload } = props.data;
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p style={{ color: "white" }}>
            Customer : {payload[0]?.payload.description}
          </p>
          <p style={{ color: "white" }}>
            Price: $ {numberFormatter(payload[0]?.payload.value, 2)}
          </p>
          <p style={{ color: "white" }}>
            Qty Purchased: {payload[0]?.payload.volume}
          </p>
          <p style={{ color: "white" }}>
            Revenue: $ {numberFormatter(payload[0]?.payload.revenue, 2)}
          </p>
          <p style={{ color: "white" }}>
            "Customer Segment : {payload[0]?.payload.description}
          </p>
          <p style={{ color: "white" }}>
            "Quadrant : {payload[0]?.payload.quadrant}
          </p>
        </div>
      );
    }

    return null;
  };

  const RenderDot = (props:any) => {

    return (
      <Dot cx={props?.props?.cx} cy={props?.props?.cy}  fill={props?.props?.payload?.customer===selectedCustomerData.customer?'#A4f504':'#ffff00'} r={props?.props?.payload?.customer===selectedCustomerData.customer?10:5} />
    )
  }

  const formatNumber=(num:string)=>{
    return `$${num}`
  }

  return (
    <div style={{ width: "100%", marginTop: 20,height:'100%' }}>
      <ResponsiveContainer width={"99%"} height={'100%'}>
        <ScatterChart
          margin={{
            top: 10,
            right: 0,
            bottom: 0,
            left: 5,
          }}
        >
          <XAxis
            type="number"
            dataKey="index"
            tick={false}
            
            domain={['dataMin', 'dataMax']}
            interval={0}
            ticks={[
              0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8,
              8.5, 9, 9.5, 10, 10.5,11,
            ]}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            type="number"
            dataKey="value"
            style={{fontSize:12,fontWeight:'bold'}}
            tick={{fill:'white'}}
            strokeWidth={0}
            height={10}
            width={80}
            interval={1}
            axisLine={false}
            tickFormatter={(value: string) => value && formatNumber(value)}
            label={{ value: 'Price/Unit($)', angle: -90, position: 'insideLeft',fill: 'white' }}
          />
          <Tooltip
            content={($) => <CustomTooltip data={$} />}
            cursor={{ strokeDasharray: "3 3" }}
            wrapperStyle={{ zIndex: 100 }}
          />
          {graphData.map((value: any, index: any) => {
            
            return (
              <>
                <ReferenceArea
                  x1={value?.xAxis - 0.5}
                  x2={value?.xAxis + 0.5}
                  y1={minYAxis}
                  y2={maxYAxis}
                  fillOpacity="0.6"
                  fill="#404040"
                  alwaysShow={true}
                  stroke="#eeeeee"
                  ifOverflow="extendDomain"
                  strokeOpacity={1}
                />
                <ReferenceLine
                  segment={[
                    { x: value?.xAxis - 0.5, y: value?.referenceLine },
                    { x: value?.xAxis + 0.5, y: value?.referenceLine },
                  ]}
                  // isFront={true}
                  fillOpacity={0}
                  strokeOpacity={1}
                  strokeWidth={1}
                  alwaysShow={true}
                  stroke="#815252"
                  strokeDasharray="8 4"
                >
                  <Label value={`$${value?.referenceLine}`} offset={0} position="right" fill="white"  style={{fontSize:11}}/>
                </ReferenceLine>
                <Scatter data={value.data} shape={($:any)=><RenderDot props={$}/>} />
              </>
            );
          })}
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ScatterCharts;
